import React from "react";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {withStyles} from "@mui/styles";


const styles = {
  filterField: {
    minWidth: 150,
    width: 150,
    maxWidth: 150,
  },
  filterBox: {
    flex: 1,
  },
};
function ListFilter({label, filterList, selectedItems, handleSelect, classes}) {

  return (
      <div className={classes.filterBox}>
        <FormControl className={classes.filterField} variant="standard">
          <InputLabel shrink>
            {label} ({filterList.length})
          </InputLabel>
          <Select
            multiple
            value={selectedItems}
            onChange={handleSelect}
            variant="standard"
          >
            {filterList.map(item => <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>)}
          </Select>
        </FormControl>
      </div>
  );
}

export default withStyles(styles)(ListFilter);